/**
 * Send a domain event to our  cloudfunctions
 * @param topic the topic to send the domain event to.
 * @param type The event type to raise
 * @param eventData aditional data to include in the event
 * @param orderKey
 */
export async function sendDomainEvent<T>(
  topic: DomainEventTopic,
  type: string,
  eventData: Record<string, unknown>,
  orderKey: string,
) {
  const { getBearerTokenHeader } = useApi()
  const {
    public: { CF_NEW_GATEWAY_URL },
  } = useRuntimeConfig()

  const url = ['domain-events', topic, type].join('/')

  return await $fetch<T>(url, {
    headers: { ...(await getBearerTokenHeader()) },
    baseURL: CF_NEW_GATEWAY_URL,
    method: 'POST',
    body: eventData,
    query: {
      orderKey,
    },
  })
}
